import "@/index.css"
import App from "@/screens/App"
import { setupVersionCheck } from "@/util/version-check"
import "@js-joda/locale_en-us"
import "@js-joda/timezone"
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: console.error }),
  mutationCache: new MutationCache({ onError: console.error }),
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)

setupVersionCheck()
